<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司动态</span>
          </div>
          <!-- <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>行业动态</span>
          </div> -->
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in pagedData" :key="index" >
            <div class="item-img" v-lazy:background-image="imgserver + item.img"></div>

            <p class="item-list-title">{{item.title}}</p>
            <p class="item-list-content">{{item.content}}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.id }}"
              >
                <img src="../assets/img/sanjiao.png" />
                <span>查看详情</span>
              </router-link>
            </div>
          </div>         
        </div>
        <div class="page-div">
          <button @click="currentPage--" :disabled="currentPage <= 1">上一页</button>
          <span>第 {{ currentPage }} 页</span>
          <button @click="currentPage++" :disabled="currentPage >= totalPages">下一页</button>
        </div>
      </div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import Banner from "../components/Banner";
import Bottom from "../components/Bottom"; 
export default {
  name: "news",
  components: {
    Banner,
    Bottom
  },
  data() {
    return {
      loading: true,
      newsList: [],
      newstype: 1,
      //分页
      currentPage: 1,
      pageSize: 3,
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.newsList.length / this.pageSize);
    },
    pagedData() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.newsList.slice(start, end);
    }
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`/gw/news/index/?type=${this.newstype}&num=6`)
        .then(response => {
          //console.log(response);
          this.newsList = response.data;
          this.loading = false;
          //window.console.log(this.newsList);
        })
        .catch(function(error) {
          window.console.log(error);
        });
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #EDF1F2;
  position: relative;
  overflow: hidden;

  .page-div{
    text-align: center;
    font-size: 18px;
    color: #666;
    button{
      font-size: 18px;
      padding: 10px 30px;
      margin: 0 20px;
      border: 1px #bfbfbf solid;
      border-radius: 0;
      margin: 20px 5px;
      text-transform: uppercase;
      display: inline-block;
      padding: 5px 14px;
      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 5px;
    }
  }

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 100%;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
     // border: 1px solid red;

      .content-nav {
        width: 30%;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid wheat;

        &-btn {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          font-size: 18px;
          color: #666;
        }
      }

      .content-nav-item {
        width: 100%;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>